<template>
    <div class="report-check">
        <div class="data-content">
            <div class="table-head">
                <div class="table-title">
                <span style="font-weight: bold">举报审核
                    <span v-if="this.filterData.local_invite_code  && this.filterData.local_invite_code.length >0 ">
                        (总共审核:{{dataList.length}}个，{{getCurrentUserUnHandleCount}}个未审核)
                    </span>
                    <span v-else>
                        (未审核:{{totalCount}}个，当前用户{{dataList.length}}个未审核)
                    </span>
                </span>
                </div>
                <div class="filter-head" style="z-index: 999;">
                    <div class="filter-item" style="width: 4rem; margin-right: 10px;">
                        <Select v-model="filterData.local_sort_type" clearable style="min-width: 80px;">
                            <Option
                              v-for="item in filterOption.localReportSortList"
                              :value="item.value"
                              :key="item.value">{{item.label }}
                            </Option>
                        </Select>
                    </div>
                    <div class="filter-item" style="width: 6rem; margin-right: 10px;">
                        <Select v-model="filterData.local_report_type" clearable style="min-width: 80px;">
                            <Option
                              v-for="item in filterOption.localReportTypeList"
                              :value="item.value"
                              :key="item.value"
                            >
                              {{item.label }}
                            </Option>
                        </Select>
                    </div>
                    <div class="filter-item" style="width: 8rem; margin-right: 10px;">
                        <Input
                            v-model="filterData.local_invite_code"
                            maxlength="6"
                            placeholder="被举报人身份ID"
                            clearable
                            style="min-width: 6rem; "/>
                    </div>
                    <Button @click="getData()">搜索</Button>
                </div>
            </div>
            <div >
                <Table :show-header ="false" :columns="columns" :data="changeDataList" @on-selection-change="selected" >
                    <template slot-scope="{ row, index }" slot="datetime" >
                        <div class="avatar">
                            <Poptip trigger="hover" :transfer="true" title="图片详情">
                                <div class="info-pop" slot="content">
                                    <img :src="row.avatar" class="img-avatar-preview">
                                </div>
                                <img :src="row.avatar" class="img-avatar">
                            </Poptip>
                        </div>
                        <div class="report-content">
                            <div>
                                <div class="report-normal" style="width: 240px;">{{ row.nickname }}</div>
                                <div class="report-normal" style="margin-left: 30px;">处理状态：<span :style="row.handle_status_color">{{row.handle_status_text}}</span></div>
                            </div>
                            <div>
                                <div class="report-normal" style="width: 240px; color: #CCCCCC;">身份ID：{{ row.invite_code }}</div>
                                <div class="report-normal" style="color: #CCCCCC;margin-left: 30px;">{{ row.created_at }}</div>
                            </div>
                            <div class="report-bottom">
                                <div class="report-desc">{{ row.content }}</div>
                                <div class="report-img-container">
                                    <span v-for="item of getImageList(row)" class="report-img">
                                        <Poptip trigger="hover" :transfer="true" title="图片详情">
                                            <div class="info-pop" slot="content">
                                                <img :src="item" style="height: 400px;">
                                            </div>
                                            <img :src="item" class="report-image">
                                        </Poptip>
                                    </span>
                                </div>
                                <div class="report-type">
                                  <div style="display: inline-block;">类型：{{ row.type_title }}</div>
                                  <div style="display: inline-block; padding-left: 10px;"> 对象：{{ row.obj_type_title }}</div>
                                  <div style="display: inline-block; padding-left: 10px;">
                                      <Button
                                      type="error"
                                      size="large"
                                      :disabled = "row.obj_type == 1"
                                      @click="reportProcessOtherInfoButton(row)"
                                    >删除{{ row.obj_type_title }}</Button>
                                  </div>
                                </div>
                                <div class="report-type" v-if="row.obj_type == 2">
                                    <div style="display: inline-block;"> 砖类型：{{ row.obj_type_sub_title }}</div>
                                    <div style="display: inline-block; padding-left: 10px;"> 标签：{{ row.brick_tag_title }}</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </Table>
            </div>
            <div style=" width: 340px; z-index: 998; position: fixed; top:150px; right: 20px; height: 100%;">
                <div style=" padding:10px; background-color: #EEEEEE; overflow: scroll; height: 80%; border-radius: 10px;border: 2px solid #DDDDDD;">
                    <div style="float:left;width: 300px;">
                        <div style="float:left;font-size:16px; color: #000000;">
                            被举报用户信息
                        </div>
                        <div style="float: right; ">
                            <Button
                                type="error"
                                size="small"
                                :disabled = "user.id <=0 || user.id === undefined || user.id == 861149 || user.id == 3016840 || user.id == 8098576"
                                @click="reportProcessUserInfoButton()">清除信息</Button>
                        </div>
                    </div>
                    <div class="avatar" style="display: inline-block;">
                        <Poptip trigger="hover" :transfer="true" title="图片详情">
                            <div class="info-pop" slot="content">
                                <img :src="user.avatar" class="img-avatar-preview">
                            </div>
                            <img :src="user.avatar" class="img-avatar">
                        </Poptip>
                    </div>
                    <div style="display: inline-block; margin-top: 20px; margin-left: 10px; color: #000000; width: 240px;">
                        <div> 昵称：{{user.nickname}}</div>
                        <div style="margin-top: 6px;"> 身份ID：{{user.invite_code}}</div>
                    </div>
                    <div style=" margin-top: 20px;  color: #000000;">
                        <div> 创建时间：{{user.created_at}}</div>
                        <div> 备考目标：{{user.goal}}</div>
                        <div> 签名：{{user.signature}}</div>
                        <div> 学校：{{user.school}}</div>
                        <div v-if="user.wall_released_time == '' || user.wall_released_time == null">CoWall禁言放出时间：暂无</div>
                        <div v-else>CoWall禁言放出时间：<span style="color: red;">{{user.wall_released_time}}</span></div>
                        <div v-if="user.chat_released_time == '' || user.chat_released_time == null">小纸条禁言放出时间：暂无</div>
                        <div v-else>小纸条禁言放出时间：<span style="color: red;">{{user.chat_released_time}}</span></div>
                        <div> 账号状态： <span :style="user.app_status_color">{{user.app_status}}</span></div>
                        <div> 警告次数： <span :style="user.notice_color">{{user.notice_count}}次</span></div>

                    </div>
                    <div style=" margin-top: 10px;  color: #000000; font-size: 16px;">
                        <div style="width: 100%;height: 2px; background-color: #DDDDDD; margin-bottom:10px;"></div>
                        <div style="float:left; margin-bottom:10px;">
                            <Button
                                type="success"
                                size="large"
                                :disabled = "dataList.length <= 0 || dataList[0].handle_status !=-1 || disableCancel"
                                @click="reportProcessButton(dataList[0])">忽略
                            </Button>
                        </div>
                        <div style="float:right; margin-bottom:10px;">
                            <Button
                                type="primary"
                                size="large"
                                style="width: 120px;"
                                :disabled = "user.id<=0 || disableHandleUser"
                                @click="reportProcessAllButton()">处理
                            </Button>
                        </div>
                        <div class="user-nickname">处理选择，请勾选要处理的选项</div>
                            <label style="float:left;margin-top:11px;cursor:pointer">
                                <input name="全部" type="checkbox" v-model="processCoWallValue" style="zoom: 140%;" />
                                <span style="display: inline-block; vertical-align: middle; margin-bottom: 11px;font-weight:normal; margin-right: 40px;">是否删除CoWall24小时砖</span>
                            </label>
                            <label style="float:left;margin-top:11px;cursor:pointer">
                                <input name="全部" type="checkbox" v-model="processAlertValue" style="zoom: 140%;" />
                                <span style="display: inline-block; vertical-align: middle; margin-bottom: 11px;font-weight:normal;">是否发送警告小纸条，通过信使小Co</span>
                            </label>
                            <div style="float: left; margin-left: 20px; margin-bottom: 10px;">
                                <div class="modal1-div">
                                <span style="margin-right: 10px;">警告文案</span>
                                    <Select
                                        v-model="localAlartData"
                                        clearable
                                        size="small"
                                        style="min-width: 100px; width:220px">
                                        <Option
                                            v-for="item in filterOption.localReportAlertTitleList"
                                            :value="item.value"
                                            :key="item.value">{{item.label}}
                                        </Option>
                                    </Select>
                                </div>
                                <div class="add-item">
                                    <span>发送内容：</span>
                                    <Input
                                        class="input"
                                        type="textarea"
                                        :rows="6"
                                        v-model="content"
                                        placeholder="请输入发送内容"
                                        clearable/>
                                </div>
                            </div>
                            <label style="float:left;margin-top:11px;cursor:pointer">
                                <input name="全部" type="checkbox" v-model="processDisableSendMsgValue" style="zoom: 140%;" />
                                <span style="display: inline-block; vertical-align: middle; margin-bottom: 11px;font-weight:normal;">是否禁言CoWall或小纸条</span>
                            </label>
                            <div style="float: left; margin-left: 20px;">
                                <div class="modal1-div">
                                    <span style="margin-right: 10px;">禁言类型</span>
                                    <Select
                                        v-model="reportDisableSendMsgType"
                                        clearable
                                        size="small"
                                        style="min-width: 100px; width:30%">
                                        <Option
                                          v-for="item in filterOption.reportDisableSendMsgTypeList"
                                          :value="item.value"
                                          :key="item.value">{{item.label }}
                                        </Option>
                                    </Select>
                                </div>
                                <div class="modal1-div">
                                    <span style="margin-right: 10px;">禁言天数</span>
                                    <Select
                                        v-model="reportDisableSendMsgDays"
                                        clearable
                                        size="small"
                                        style="min-width: 100px; width:30%">
                                        <Option
                                          v-for="item in filterOption.reportDisableSendMsgDaysList"
                                          :value="item.value"
                                          :key="item.value">{{item.label}}
                                        </Option>
                                    </Select>
                                </div>
                                <div class="modal1-div">{{getDisableSendMsgTip}}</div>
                            </div>
                            <label style="float:left;margin-top:11px;cursor:pointer">
                                <input name="全部" type="checkbox" v-model="processBannedValue" style="zoom: 140%;" />
                                <span style="display: inline-block; vertical-align: middle; margin-bottom: 11px;font-weight:normal;width: 240px;">是否封禁用户</span>
                            </label>
                            <div style="float: left; margin-left: 20px;">
                                <div class="modal1-div">
                                    <span>举报分类为</span>
                                    <Select
                                      v-model="modal1Data.report_type"
                                      clearable
                                      size="small"
                                      style="min-width: 100px; width:30%"
                                    >
                                    <Option
                                        v-for="item in filterOption.reportTypeList"
                                        :value="item.value"
                                        :key="item.value">
                                        {{item.label }}
                                    </Option>
                                    </Select>
                                </div>
                                <div class="modal1-div">
                                    <span>应关入</span>
                                    <Input
                                      v-model="modal1Data.ban_days"
                                      size="small"
                                      placeholder="输入应关入天数"
                                      clearable
                                      style="min-width: 100px; width:30%"
                                    />
                                    <span>天</span>
                                </div>
                                <div class="modal1-div"><span style="color: red;">{{modal1Data.msg}}</span>{{getModal1Msg}}</div>
                                <div style="height: 20px;"></div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apis from "../../http/api";
import commonApi from "../../utils/commonapi";

export default {
  name: "ReportCheck",
  components: {},
  data() {
    return {
      filterOption: {
        localReportSortList:[{'label':'正序','value':'asc'},{'label':'倒序','value':'desc'}],
        localReportTypeList:[{'label':'全部','value':-1},{'label':'垃圾营销','value':1},{'label':'虚假信息','value':7},{'label':'涉黄信息','value':2},{'label':'人身攻击','value':3},{'label':'有害信息','value':4},{'label':'诈骗信息','value':6},{'label':'违法信息','value':5},{'label':'挂机占座','value':8},{'label':'其他','value':0}],
        localReportAlertTitleList:[
            {
                'label':'CoWall营销或不良信息情况',
                'value':0,
                'desc':'你近期在CoWall发出的砖，经审核存在营销或不良信息情况，现对该砖进行删除处理；如反复发送营销或不良信息，情节严重可能会导致禁言或封号哦。\nCoWall是大家分享与收获温暖的地方；这面墙由大家一起筑起、更需要大家一起维护哦！'
            },
            {
                'label':'CoWall标签错配情况',
                'value':1,
                'desc':'你近期在CoWall发出的砖，经审核存在标签错配情况，现对该砖进行删除处理；如反复标签错配，可能会导致禁言哦。\n来看看不同标签对应的内容吧～\n[打卡监督]标签可以用来打卡每天的自习或睡眠、记录大家的学习生活；还可以用来接受其他Co岛居民对自己学习生活的监督哦。\n[学习交流]标签可以用来进行学习上的互帮互助，例如难题求解、互相讨论、学习建议等；也可以分享自己在学习过程中的感想经验、心得体会、解题方法哦～\n[心情日常]标签可以用来分享自己的不同心情，记录自己日常遇到的事情；相信不同的生活点滴，可以打动不同的人～\n[Co岛生活]标签可以记录大家在Co岛上的生活哦！不管是找寻Co伴、探索Co岛的功能，还是宣传自己的空间、分享形象搭配等，和Co岛有关的一切都可以被放在这里哦！'
            },
            {
                'label':'小纸条营销或不良信息情况',
                'value':2,
                'desc':'你近期在小纸条或者群聊中的发言，经审核存在营销或不良信息情况，本次予以警告；若反复发送营销或不良信息，情节严重可能会导致禁言或封号哦。'
            },
            {
                'label':'用户头像或昵称仿冒官方',
                'value':3,
                'desc':'你的头像昵称等信息，经审核仿冒官方，本次予以警告并将相关信息清空；若反复仿冒，情节严重可能会导致禁言或封号哦。'
            },
            {
                'label':'帮助免费心理咨询热线',
                'value':4,
                'desc':'你不孤单，我们都在。\n如果需要帮助，请拨打全国24小时免费心理咨询热线：010-82951332。'
            },
        ],
        reportTypeList: [],
        reportDisableSendMsgTypeList:[{'label':'全部','value':0},{'label':'禁言CoWall','value':1},{'label':'禁言小纸条','value':2}],
        reportDisableSendMsgDaysList:[{'label':'1天','value':1},{'label':'3天','value':3},{'label':'10天','value':10},{'label':'30天','value':30},{'label':'180天','value':180},{'label':'全部','value':3650}],
      },
      filterData:{
        // 审核排序 正序或倒序（默认正序），举报类型：-1到8，被举报人身份ID，
        local_sort_type:'asc',
        local_report_type:-1,
        local_invite_code: null,
      },
      modal1Data: {
        report_type: null,
        ban_days: null,
        detention_time: null,
        msg: null,
        released_time:null,
       
      },
      disableSendMsg:false,
      reportDisableSendMsgType:0,
      reportDisableSendMsgDays:1,
      reportDisableSendMsgTip:null,
      dataList: [],
      columns: [
        {
            title: '举报记录',
            slot: 'datetime',
            sortable: true
        }
      ],
      content: '',
      totalCount: 0,
      user:{},
      processCoWallValue:false,
      processBannedValue:false,
      processDisableSendMsgValue:false,
      processAlertValue:false,
      // 警告选中的类型
      localAlartData: 0,
      // 是否能处理
      disableHandleUser: true,
      disableCancel: true,
    }
  },
  created() {
    this.getData();
    this.getOptions();
  },
  methods: {
    getData() {
      let params = {
          sort: this.filterData.local_sort_type,
          report_type: this.filterData.local_report_type,
      };
      if(this.filterData.local_invite_code){
          if(this.filterData.local_invite_code.length>0){
              params['search_type'] = 1
              params['invite_code'] = this.filterData.local_invite_code
          }
      }
      apis.report_list(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          // 使用 Vue.set 或数组的响应式更新方法来确保响应式更新
          this.dataList = data.records ? [...data.records] : [];
          this.totalCount = data.count;
          if(data.count == undefined){
              this.totalCount = 0
          }
          // 创建用户数据的副本以确保响应式更新
          if (data.user) {
            this.user = { ...data.user };
          }
          if(this.user.id == undefined){
              this.user.id = 0
          }
          console.log("userid = "+this.user.id)
          var avatar = this.user['avatar']
          if(avatar == undefined || avatar == ""){
              avatar = "webco.png"
          }
          if(avatar.startsWith("http")){
              
          }else{
              this.user['avatar'] = "https://image.co-study.com.cn/app/image/avatar/"+ avatar
          }
          // 0为正常，-1为封禁, -2是注销
          var status = '正常'
          var color = {color:"#000000"}
          switch(this.user.active){
              case -1:
                status = '封禁'
                color = {color:'red'}
                break
              case -2:
                status = '注销'
                color = {color:'gray'}
                break
              case 0:
                status = '正常'
                color = {color:'green'}
                break
              default:
                status = '未知'
                color = {color:"#000000"}
                break
          }
          this.user['app_status'] = status
          this.user['app_status_color'] = color
          if(this.user['notice_count']>0){
                this.user['notice_color'] = {color:"#FF0000"}
          }else{
                this.user['notice_color'] = {color:'gray'}
          }
          // 状态初始化
          this.processCoWallValue = false,
          this.processBannedValue = false,
          this.processDisableSendMsgValue = false,
          this.processAlertValue = false,
          // 警告选中的类型
          this.localAlartData = 0,
          // 禁言初始化
          this.reportDisableSendMsgType = 0
          this.reportDisableSendMsgDays = 1
          // 警告初始化
          this.content = '你近期在CoWall发出的砖，经审核存在营销或不良信息情况，现对该砖进行删除处理；如反复发送营销或不良信息，情节严重可能会导致禁言或封号哦。\nCoWall是大家分享与收获温暖的地方；这面墙由大家一起筑起、更需要大家一起维护哦！'
          // 封禁用户初始化
          var report_type = 0
          if(this.dataList.length>0){
              report_type = this.dataList[0].report_type
          }
          this.getBeReporterUserBannedStatus(this.user.id,report_type)
          
          var vm = this
          setTimeout(function(){
              // 放开按钮
              vm.disableHandleUser = false 
              vm.disableCancel = false 
          },500)
        }
      }).catch()
    },
    // 初始化封禁用户的基本信息
    getBeReporterUserBannedStatus(user_id,report_type) {
      let params = {
        user_id: user_id,
        report_type: report_type
      };
      apis.report_user_detention(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.modal1Data.msg = data.record.msg;
          this.modal1Data.report_type = data.record.report_type;
          this.modal1Data.detention_time = data.record.detention_time;
          this.modal1Data.ban_days = data.record.ban_days;
          this.modal1Data.released_time = data.record.released_time;
        }
      }).catch()
    },
    // 处理按钮
    reportProcessAllButton() {
        // 获取最新一条的举报ID，当没有的情况下，默认为0
        var report_id = 0
        if(this.dataList.length>0 && this.dataList[0].handle_status ==-1){
            report_id = this.dataList[0].id
        }
        let post_data = {
            report_id: report_id,
            user_id: this.user.id
        };
        var recordData = "处理操作，举报的最后一条ID："+report_id+"\n"
        var count = 1;
        if(this.processCoWallValue){
            post_data['brick_control'] = this.processCoWallValue
            recordData += count+".删除了24小时CoWall的砖\n"
            count++
        }
        if(this.processBannedValue){
            console.log("放出时间"+this.modal1Data.released_time)
            if(this.modal1Data.released_time){
              alert('该用户已封禁，请到封禁列表修改期限或放出')
              return
            }
            if (this.modal1Data.ban_days < 1) {
              alert('天数不能小于1')
              return
            }
            if (this.user.id == undefined || this.user.id<=0 ) {
              alert('当前用户信息异常')
              return
            }
            post_data['banned_info'] = {
              user_id: this.user.id,
              detention_time: this.modal1Data.detention_time,
              ban_days: parseInt(this.modal1Data.ban_days),
              detention_type: this.modal1Data.report_type
            };
            recordData += count+".举报类型为:"+this.getReportTypeTitle(this.modal1Data.report_type)+",封禁"+parseInt(this.modal1Data.ban_days) +"天"+"\n"
            count++
        }
        if(this.processDisableSendMsgValue){
            var wall_forbid_days = 0
            var chat_forbid_days = 0
            var recordContent = ""
            if(this.reportDisableSendMsgType == 0){
                wall_forbid_days = this.reportDisableSendMsgDays
                chat_forbid_days = this.reportDisableSendMsgDays
                recordContent = "禁言-全部 "+ this.reportDisableSendMsgDays + "天"
            }else if(this.reportDisableSendMsgType == 1){
                wall_forbid_days = this.reportDisableSendMsgDays
                recordContent = "禁言-CoWall "+ this.reportDisableSendMsgDays + "天"
            }else if(this.reportDisableSendMsgType == 2){
                chat_forbid_days = this.reportDisableSendMsgDays
                recordContent = "禁言-小纸条 "+ this.reportDisableSendMsgDays + "天"
            }
            post_data['forbid_info'] = {
              user_id: this.user.id,
              wall_forbid_days: parseInt(wall_forbid_days),
              chat_forbid_days: parseInt(chat_forbid_days)
            };
            recordData += count+"."+recordContent+"\n"
            count++
        }
        if(this.processAlertValue){
            post_data['notice_info'] = {
              // 0信使小Co,1小co
              from_user_type: 0,
              msg: this.content,
              user_id: this.user.id
            }
            recordData += count+".通过信使小Co发送警告内容："+this.content+"\n"
            count++
        }
        // console.log(post_data)
        // console.log(recordData)
        this.disableHandleUser = true
        apis.report_process(post_data).then(res => {
                const { data, errCode, msg } = res;
                if (errCode === 0) {
                    // 记录-举报处理
                    // 举报处理
                    commonApi.recordFromOperationReport(0, null, 0, report_id, recordData, this.user.id)
                    this.$Message.success('处理成功！')
                    this.$nextTick(() => {
                        this.getData()
                    })
                } else {
                    alert(msg)
                    this.disableHandleUser = false
                }
            }).catch(err => {
                alert('接口异常'+err)
                this.disableHandleUser = false
            })
    },
    // 清除用户信息
    reportProcessUserInfoButton() {
         let post_data = {
            user_id: this.user.id
         };
         var isNext = confirm("是否清除用户信息，请谨慎操作？")
         if(isNext){
           apis.report_handle_clear_user_info(post_data).then(res => {
             const { data, errCode, msg } = res;
             if (errCode === 0) {
               // 记录-举报处理
               commonApi.recordFromOperationReport(7, null, 0, 0, '清除用户信息：'+this.user.id,this.user.id)
               this.$Message.success('清除用户信息成功！')
               this.$nextTick(() => {
                   this.getData()
               })
             } else {
               alert(msg)
             }
           }).catch(err => {
             alert('接口异常')
           })
         }
    },
    reportProcessOtherInfoButton(row) {
         let post_data = {
            report_id: row.id
         };
         apis.report_handle_clear_info(post_data).then(res => {
           const { data, errCode, msg } = res;
           if (errCode === 0) {
             // 记录-举报处理
             commonApi.recordFromOperationReport(8, null, 0, row.id, '清除'+ row.obj_type_title+'',this.user.id)
              this.$Message.success('清除'+row.obj_type_title+'信息成功！')
             this.$nextTick(() => {
                 this.getData()
             })
           } else {
             alert(msg)
           }
         }).catch(err => {
           alert('接口异常')
         })
    },
    getCurrentUserUnHandleCount(){
        if(this.dataList.length ==0)
            return 0
        let data =  this.dataList.filter(function(item) {
                return item.handle_status == -1
        })
        return data.length
    },
    getOptions() {
      apis.report_get_options().then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          var types =data.reportTypeList
          for (var i=0;i< types.length;i++) {
              if(types[i].label == "挂机占座"){
                  types.splice(i,1)
                  break
              }
          }
          console.log("data = "+JSON.stringify(types))
          this.filterOption.reportTypeList = types;
        }
      }).catch()
    },
    selected(selecttion) {

    },
    // 忽略按钮
    reportProcessButton(row) {
        if(this.user.id <=0 || row == undefined){
            this.$Message.success('用户信息异常,或没有可忽略的数据！')
            return 
        }
        let post_data = {
            report_id: row.id,
            handle_status: 0,
        };
        this.disableCancel = true
        apis.report_process(post_data).then(res => {
            const { data, errCode, msg } = res;
            if (errCode === 0) {
                // 记录-举报处理
                commonApi.recordFromOperationReport(1, null, 0, row.id, '忽略', this.user.id)
                this.$nextTick(() => {
                    this.getData()
                })
            } else {
                alert(msg)
            }
        }).catch(err => {
          alert('接口异常')
        })
    },
    getImageList(row) {
      var images =JSON.parse(row.images)
      for (var i=0;i< images.length;i++) {
          images[i] = "https://image.co-study.com.cn/app/image/report/"+ images[i]
      }
      return images
    },
    getReportTypeTitle(currentReportType){
      var typeList = ["其他","垃圾营销","涉黄信息","人身攻击","有害信息","违法信息","咋骗信息","虚假信息"]
      if(currentReportType == undefined || currentReportType >7){
          currentReportType = 0
      }
      return typeList[currentReportType]  
    },
  },
  computed: {
    changeDataList() {
      return this.dataList.map(item => {
        // 创建 item 的深拷贝以避免修改原始数据
        const newItem = { ...item };
        var avatar = newItem['avatar']
        if(avatar == undefined || avatar == ""){
            avatar = "webco.png"
        }
        if(avatar.startsWith("http")){
            
        }else{
            newItem['avatar'] = "https://image.co-study.com.cn/app/image/avatar/"+ avatar
        }
        // 举报对象的类型
        var objTypeTitle = ["未知","用户","动态(砖)","评论","回复","教室","寝室","餐厅（店铺）","群聊"]
        var obj_type = newItem['obj_type']
        if(obj_type>8){
            obj_type = 0
        }
        newItem['obj_type_title'] = objTypeTitle[obj_type]
        
        newItem['obj_type_sub_title'] = '无'
        // obj_type == 2
        if(obj_type == 2){
            // 0-cowall, 1-自习, 2-自习总结, 3-睡眠, 4-睡眠总结 # 5 就餐  6新cowall 7此刻
            var objTypeCoWallTitle = ["旧CoWall","自习砖","自习总结砖","睡眠砖","睡眠总结砖","店铺砖","空间CoWall","此刻"]
            var remark = newItem['remark']
            if(remark == undefined || remark == ""){
                remark = "{}"
            }
            var remarkObj = JSON.parse(remark)
            var brickType = remarkObj['brick_type']
            var brickLocation = remarkObj['brick_location']
            if(brickType == undefined || brickType > 7){
                brickType = 0
            }
            if(brickLocation == undefined){
                brickLocation = "未知"
            }
            
            var tagTypeTitle = "无"
            var tagType = newItem['tag_type']
            if(tagType == undefined){
                tagType = 0
            }
            var typeList = ["未知标签","打卡监督","学习交流","心情日常","Co岛生活"]
            if(tagType > 4){
                tagTypeTitle ="暂未支持"
            }else{
                tagTypeTitle = typeList[tagType]
            }
            newItem['brick_tag_title'] = tagTypeTitle
            
            if(brickType == 6){
                // 空间CoWall 增加来源提示
                var roomTypeTitle = ["公共空间", "专属教室", "专属寝室", "专属店铺"]
                var roomType = newItem['room_type']
                if(roomType == undefined || roomType > 3){
                    roomType = 0
                }
                var roomTypeCurrentTitle = roomTypeTitle[roomType]
                newItem['obj_type_sub_title'] = roomTypeCurrentTitle +"（"+brickLocation+"）"
                if(roomType > 0){
                    newItem['brick_tag_title'] = "无"
                }
            }else{
                newItem['obj_type_sub_title'] = objTypeCoWallTitle[brickType]
            }
        }
        // 举报的类型
        var type = newItem['report_type']
        var typeList = ["其他","垃圾营销","涉黄信息","人身攻击","有害信息","违法信息","咋骗信息","虚假信息"]
        if(type == undefined || type >7){
            type = 0
        }
        newItem['type_title'] = typeList[type]
       
        // 处理结果 ：-1为未处理，0为忽略, 1为处理
        var status = '未知'
        var color = {color:"#000000"}
        switch(newItem.handle_status){
            case -1:
              status = '未处理'
              color = {color:'red'}
              break
            case 1:
              status = '已处理'
              color = {color:'#CCCCCC'}
              break
            case 0:
              status = '已忽略'
              color = {color:'green'}
              break
            default:
              status = '未知'
              color = {color:"#000000"}
              break
        }
        newItem['handle_status_text'] = status
        newItem['handle_status_color'] = color
        return newItem
      })
    },
    getCurrentUserUnHandleCount() {
      if(this.dataList.length == 0) 
        return 0
      return this.dataList.filter(item => item.handle_status == -1).length
    }
  },
  watch: {
    "localAlartData"(newVal, oldVal) {
        for (var i=0;i< this.filterOption.localReportAlertTitleList.length;i++) {
            if(this.filterOption.localReportAlertTitleList[i].value == newVal){
                this.content = this.filterOption.localReportAlertTitleList[i].desc
                break
            }
        }
    },
    "modal1Data.report_type"(newVal, oldVal) {
        // 配置默认的封禁天数
        if(newVal == 0 || newVal == 1 || newVal == 6 || newVal == 7){
            // 其他、垃圾营销、诈骗信息、虚假信息
            this.modal1Data.ban_days = 604800/(24*3600)
        }else if(newVal == 3 || newVal == 4 || newVal == 5){
            // 人身攻击、有害信息、违法信息
            this.modal1Data.ban_days = 7776000/(24*3600)
        }else if(newVal == 2){
            // 涉黄信息 9999天
            this.modal1Data.ban_days = 863913600/(24*3600)
        }
    }
  },
  filters: {
  }
}
</script>

<style scoped>
.report-check {
  margin: 10px;
}

.filter-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.filter-item {
  min-width: 80px;
  width: 12%;
  margin: 0 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text-center {
  text-align: center;
}


.table-title {
  align-self: center;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.modal1-div {
  margin-bottom: 10px;
}

.info-pop {
  white-space: pre-wrap;
}
.avatar{
    float: left;
    width: 50px;
    margin-top: 20px;
}
.img-avatar{
    width: 50px;
    height: 50px;
    border-radius: 50%;
}
.img-avatar-preview{
    width: 400px;
    height: 400px;
}
.report-content{
    float: left;
    width: 500px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
}
.user-nickname{
    font-weight:bold;
    float: left;
    font-size: 16px;
    width: 300px;
    color: #000000;
}
.user-created-at{
    font-weight:normal;
    font-size: 16px;
    float: right;
    color: #cccccc;
}
.user-invite-code{
    font-weight:bold;
    float: left;
    font-size: 14px;
    margin-top: 8px;
    width: 300px;
    color: #cccccc;
}
.user-report-type{
    font-weight:normal;
    font-size: 14px;
     margin-top: 8px;
    float: right;
    color: #cccccc;
}
.report-bottom{
    float: left;
    margin-top: 8px;
    width: 500px;
}
.report-desc{
    font-weight:normal;
    width: 440px;
    font-size: 16px;
    color: #000000;
}
.report-img-container{
    margin-top: 20px;
}
.report-img{
    margin-right: 20px;
}
.report-image{
   width: 80px;
   height: 80px; 
}
.report-type{
    font-weight:bold;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #000000;
}
.report-normal{
    display: inline-block;
    font-size: 1rem;
    font-weight: bold;
    color: #000000;
    vertical-align: top;
}
</style>
